/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SafeDepositBoxSafeLocationOption } from './SafeDepositBoxSafeLocationOption';
import {
    SafeDepositBoxSafeLocationOptionFromJSON,
    SafeDepositBoxSafeLocationOptionFromJSONTyped,
    SafeDepositBoxSafeLocationOptionToJSON,
    SafeDepositBoxSafeLocationOptionToJSONTyped,
} from './SafeDepositBoxSafeLocationOption';
import type { SafeDepositBoxSignatureAuthorityOption } from './SafeDepositBoxSignatureAuthorityOption';
import {
    SafeDepositBoxSignatureAuthorityOptionFromJSON,
    SafeDepositBoxSignatureAuthorityOptionFromJSONTyped,
    SafeDepositBoxSignatureAuthorityOptionToJSON,
    SafeDepositBoxSignatureAuthorityOptionToJSONTyped,
} from './SafeDepositBoxSignatureAuthorityOption';
import type { SafeDepositBoxSafeSizeOption } from './SafeDepositBoxSafeSizeOption';
import {
    SafeDepositBoxSafeSizeOptionFromJSON,
    SafeDepositBoxSafeSizeOptionFromJSONTyped,
    SafeDepositBoxSafeSizeOptionToJSON,
    SafeDepositBoxSafeSizeOptionToJSONTyped,
} from './SafeDepositBoxSafeSizeOption';
import type { SafeDepositBoxSafeRoleOption } from './SafeDepositBoxSafeRoleOption';
import {
    SafeDepositBoxSafeRoleOptionFromJSON,
    SafeDepositBoxSafeRoleOptionFromJSONTyped,
    SafeDepositBoxSafeRoleOptionToJSON,
    SafeDepositBoxSafeRoleOptionToJSONTyped,
} from './SafeDepositBoxSafeRoleOption';

/**
 * 
 * @export
 * @interface SafeDepositBoxServiceRoleOptions
 */
export interface SafeDepositBoxServiceRoleOptions {
    /**
     * 
     * @type {Array<SafeDepositBoxSafeRoleOption>}
     * @memberof SafeDepositBoxServiceRoleOptions
     */
    safeRoles: Array<SafeDepositBoxSafeRoleOption>;
    /**
     * 
     * @type {Array<SafeDepositBoxSignatureAuthorityOption>}
     * @memberof SafeDepositBoxServiceRoleOptions
     */
    signatureAuthorities: Array<SafeDepositBoxSignatureAuthorityOption>;
    /**
     * 
     * @type {Array<SafeDepositBoxSafeLocationOption>}
     * @memberof SafeDepositBoxServiceRoleOptions
     */
    safeLocations?: Array<SafeDepositBoxSafeLocationOption>;
    /**
     * 
     * @type {Array<SafeDepositBoxSafeSizeOption>}
     * @memberof SafeDepositBoxServiceRoleOptions
     */
    safeSizes?: Array<SafeDepositBoxSafeSizeOption>;
}

/**
 * Check if a given object implements the SafeDepositBoxServiceRoleOptions interface.
 */
export function instanceOfSafeDepositBoxServiceRoleOptions(value: object): value is SafeDepositBoxServiceRoleOptions {
    if (!('safeRoles' in value) || value['safeRoles'] === undefined) return false;
    if (!('signatureAuthorities' in value) || value['signatureAuthorities'] === undefined) return false;
    return true;
}

export function SafeDepositBoxServiceRoleOptionsFromJSON(json: any): SafeDepositBoxServiceRoleOptions {
    return SafeDepositBoxServiceRoleOptionsFromJSONTyped(json, false);
}

export function SafeDepositBoxServiceRoleOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeDepositBoxServiceRoleOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'safeRoles': ((json['safeRoles'] as Array<any>).map(SafeDepositBoxSafeRoleOptionFromJSON)),
        'signatureAuthorities': ((json['signatureAuthorities'] as Array<any>).map(SafeDepositBoxSignatureAuthorityOptionFromJSON)),
        'safeLocations': json['safeLocations'] == null ? undefined : ((json['safeLocations'] as Array<any>).map(SafeDepositBoxSafeLocationOptionFromJSON)),
        'safeSizes': json['safeSizes'] == null ? undefined : ((json['safeSizes'] as Array<any>).map(SafeDepositBoxSafeSizeOptionFromJSON)),
    };
}

export function SafeDepositBoxServiceRoleOptionsToJSON(json: any): SafeDepositBoxServiceRoleOptions {
    return SafeDepositBoxServiceRoleOptionsToJSONTyped(json, false);
}

export function SafeDepositBoxServiceRoleOptionsToJSONTyped(value?: SafeDepositBoxServiceRoleOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'safeRoles': ((value['safeRoles'] as Array<any>).map(SafeDepositBoxSafeRoleOptionToJSON)),
        'signatureAuthorities': ((value['signatureAuthorities'] as Array<any>).map(SafeDepositBoxSignatureAuthorityOptionToJSON)),
        'safeLocations': value['safeLocations'] == null ? undefined : ((value['safeLocations'] as Array<any>).map(SafeDepositBoxSafeLocationOptionToJSON)),
        'safeSizes': value['safeSizes'] == null ? undefined : ((value['safeSizes'] as Array<any>).map(SafeDepositBoxSafeSizeOptionToJSON)),
    };
}

